module.exports = __webpack_public_path__ + "media/images/goutte-mobile-fa8e7c45e3c45b1fdb9ad4224893ad14.jpg";